import { fromSeconds, getUnitResource } from "@core/Util/time";

import loadResourceString from "@core/Util/resources";

//Use getters due to our resources potentially not being available yet on load
const RESOURCE_SETS = {
  journey: {
    get title() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_Title') },
    get description() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_Description') },
    get actionLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_ActionLabel') },
    get pauseDurationTypeLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_PauseDurationTypeLabel') },
    get pauseFinishedObjectActionLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_PauseFinishedObjectActionLabel') },
    get pauseFinishedRecordActionLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_PauseFinishedRecordActionLabel') },
    get summaryWithPause() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_SummaryWithPause') },
    get summaryWithDelete() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_SummaryWithDelete') },
    get confirmation() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Journey_Confirmation') }
  },
  connection: {
    get title() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_Title') },
    get description() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_Description') },
    get actionLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_ActionLabel') },
    get pauseDurationTypeLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_PauseDurationTypeLabel') },
    get pauseFinishedObjectActionLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_PauseFinishedObjectActionLabel') },
    get pauseFinishedRecordActionLabel() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_PauseFinishedRecordActionLabel') },
    get summaryWithPause() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_SummaryWithPause') },
    get summaryWithDelete() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_SummaryWithDelete') },
    get confirmation() { return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_Connection_Confirmation') }
  }
}

const OPTIONS = {
  ACTIONS: {
    pause: 'pause',
    stop: 'stop'
  },

  PAUSE_DURATION_TYPES: {
    indefinite: 'indefinite',
    period: 'period'
  },

  PAUSE_FINISHED_OBJECT_ACTION: {
    reactivate: 'reactivate',
    stop: 'stop'
  },

  PAUSE_FINISHED_RECORDS_ACTION: {
    process: 'process',
    delete: 'delete'
  }
};

const helpers = {
  /**
   * Determine whether the given configuration will delete records or not
   * @param {OPTIONS.ACTIONS} action
   * @param {OPTIONS.PAUSE_FINISHED_OBJECT_ACTION} pauseFinishedObjectAction
   * @param {OPTIONS.PAUSE_FINISHED_RECORDS_ACTION} pauseFinishedRecordAction
   * @return {boolean}
   */
  willDeleteRecords(
    action, 
    pauseFinishedObjectAction, 
    pauseFinishedRecordAction
  ) {
    return action === OPTIONS.ACTIONS.stop ||
      pauseFinishedObjectAction === OPTIONS.PAUSE_FINISHED_OBJECT_ACTION.stop ||
      pauseFinishedRecordAction === OPTIONS.PAUSE_FINISHED_RECORDS_ACTION.delete
  },

  /**
   * Generate a formatted pause duration
   * @param {OPTIONS.PAUSE_DURATION_TYPES} pauseDurationType
   * @param { { seconds: Number, unit: String }|undefined } pauseDuration
   */
  formatPauseDurationLabel(pauseDurationType, pauseDuration) {
    if(
      pauseDurationType === OPTIONS.PAUSE_DURATION_TYPES.period &&
      pauseDuration
    ) {
      const duration = fromSeconds(pauseDuration.seconds, pauseDuration.unit);
      const timeUnitResource = loadResourceString(getUnitResource(pauseDuration.unit, duration));
      
      return `${duration} ${timeUnitResource}`;
    }

    //Assume we are indefinite
    return loadResourceString('JourneyBuilder_DeactivateConfirmationPopup_IndefinitePauseDuration');
  }
}

export {
  helpers,
  OPTIONS,
  RESOURCE_SETS
}